module.exports = __webpack_public_path__ + "img/networking.5ccd301a.jpg";